import React from 'react';
import { Dropdown, Card, Image, Table, Button, Icon, Popup } from 'semantic-ui-react';
import { scientificFormat } from '../../utils/helpers/formatting';
import { YoutubeIcon, InstagramIcon, TwitterIcon, FacebookIcon } from '../../components/dyzio-icons';

const DIVIDER = 'divider';

const smallText = {
  fontSize: '80%',
  lineHeight: '10px',
};

const LargeCard = ({ influencer, dropdownOptions }) => (
  <Card key={influencer.id}>
    <Card.Content>
      <Card.Header>
        <Table basic="very" fluid singleLine compact>
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell style={{ padding: 0 }}>{influencer.name}</Table.HeaderCell>
              <Table.Cell collapsing style={{ padding: 0 }}>
                <Dropdown
                  icon={null}
                  pointing="top right"
                  floating
                  trigger={<Button icon="bars" color="pink" floated="right" size="mini" />}
                >
                  <Dropdown.Menu>
                    {
                      _.map(dropdownOptions, opt => {
                        if (opt.type === DIVIDER) {
                          return (<Dropdown.Divider />);
                        }

                        if (opt.disabled && opt.popupText) {
                          return (
                            <Popup
                              trigger={
                                <Dropdown.Item
                                  onClick={_.noop()}
                                  value={opt.value}
                                >
                                  <Icon name={opt.icon} />{opt.label}
                                </Dropdown.Item>
                              }
                              content={opt.popupText}
                            />
                          );
                        }

                        return (
                          <Dropdown.Item
                            disabled={opt.disabled}
                            onClick={opt.onClick}
                            value={opt.value}
                          >
                            <Icon name={opt.icon} />{opt.label}
                          </Dropdown.Item>
                        );
                      })
                    }
                  </Dropdown.Menu>
                </Dropdown>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Header>
    </Card.Content>

    <Card.Content>
      <Image
        src={influencer.thumbnail}
        size="small"
        centered
        shape="circular"
        style={{ display: 'block' }}
      />
    </Card.Content>

    <Card.Content style={{ padding: '5px 10px' }}>
      <Table basic="very" fluid singleLine compact>
        <Table.Body>
          <Table.Row>
            <Table.Cell collapsing style={{ padding: 0 }}><YoutubeIcon /></Table.Cell>
            <Table.Cell style={smallText}>{influencer.youtubeChannelTitle}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{scientificFormat(influencer.youtubeCount)}</Table.Cell>
            <Table.Cell collapsing style={smallText}></Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell collapsing style={{ padding: 0 }}><InstagramIcon /></Table.Cell>
            <Table.Cell style={smallText}>{influencer.instagram}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{scientificFormat(influencer.instagramCount)}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{influencer.instagramVerified && <Icon name="check circle" color="blue" />}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell collapsing style={{ padding: 0 }}><TwitterIcon /></Table.Cell>
            <Table.Cell style={smallText}>{influencer.twitter}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{scientificFormat(influencer.twitterCount)}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{influencer.twitterVerified && <Icon name="check circle" color="blue" />}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.Cell collapsing style={{ padding: 0 }}><FacebookIcon /></Table.Cell>
            <Table.Cell style={smallText}>{influencer.facebook}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{scientificFormat(influencer.facebookCount)}</Table.Cell>
            <Table.Cell collapsing style={smallText}>{influencer.facebookVerified && <Icon name="check circle" color="blue" />}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Card.Content>
  </Card>
);

export default LargeCard;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-influencers/large-card.js
 **/